import { api } from '@/lib/api';
import { ApiError } from '@/lib/api-errors';

interface OccurrenceRow {
  id: string;
  occurrenceDate: string;
}

/**
 * One contribution row carries the amount. Linking it to a service reuses the
 * occurrence for that date instead of creating a second gift.
 */
export const resolveOfferingOccurrence = async (
  programId: string,
  occurrenceDate: string,
  venueId?: string | null,
): Promise<string> => {
  const existing = await findOccurrence(programId, occurrenceDate);
  if (existing) return existing;

  try {
    const created = await api.post<OccurrenceRow>(`/programs/${programId}/occurrences`, {
      occurrenceDate,
      venueId: venueId ?? null,
    });
    return created.id;
  } catch (err) {
    if (err instanceof ApiError && err.code === 'OCCURRENCE_DATE_TAKEN') {
      const raced = await findOccurrence(programId, occurrenceDate);
      if (raced) return raced;
    }
    throw err;
  }
};

const findOccurrence = async (programId: string, occurrenceDate: string): Promise<string | null> => {
  const params = new URLSearchParams({
    programId,
    fromDate: occurrenceDate,
    toDate: occurrenceDate,
    pageSize: '20',
  });
  const listed = await api.get<{ data: OccurrenceRow[] }>(`/occurrences?${params}`);
  return listed.data.find((row) => row.occurrenceDate === occurrenceDate)?.id ?? null;
};
